import React from 'react'
import './ToHead.css'

export default function ToHead() {
  return (
    <div className="bg-tohead">
      <a href="#toHeader" className=""><i className="fas fa-chevron-circle-up tohead"></i></a>
    </div>
  )
}
